<template>
  <div class="whoami">
    <b-container class="whoami_container">
      <h1 class="pull-left whoami_title">
        <font-awesome-icon icon="user-alt" />
        Qui suis-je ?
      </h1>
      <hr class="white-hr" />
      <b-row>
        <b-col lg="8" xl="8" sm="12" class="whoami_text">
          <b-jumbotron fluid class="whoami_text_jumb" bg-variant="light">
            <p v-html="whoamiPresentation"></p>
          </b-jumbotron>
        </b-col>
        <b-col lg="3" xl="3" sm="12" class="whoami_img_col">
          <b-img
            class="whoami_img"
            rounded="circle"
            fluid
            thumbnail
            :src="require('../assets/img/moi.png')"
            alt="coach formation télétravail"
          ></b-img>
          <div class="social_links">
            <a href="https://twitter.com/AlexDevNomade" target="_blank">
              <font-awesome-icon :icon="['fab', 'twitter']" />
            </a>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { whoamiPresentation } from "@/data/texts";

export default {
  name: "WhoAmI",
  data() {
    return {
      whoamiPresentation: whoamiPresentation,
    };
  },
};
</script>
